export const environment = {

    // homepage modifiers
    emergencyEnabled: false,
    emergencyTileEnabled: false,
    emergencyBannerHidden: true,
    showHowItWorks: false,
    showPricingInfo: true,
    showBookingWindows: true,

    jobPrefix: 'ER',
    production: false,
    clientID: 3978,
    productName: "AA Home Book a Job",
    flatAdminFee: 38.33,
    GST: 0.15,
    coverageAreaText: "We are currently available in Auckland.",
    googleMapsCountries: ['nz'],
    countryCodeSelectorCountries: ['nz', 'au'],
    outOfHoursEnabled: false,
    blockMondayOnWeekend: true,
    bundlingEnabled: false,
    emergencyTriageEnabled: false,
    emergencyAfterHoursStart: 17.00,
    emergencyAfterHoursEnd: 8.30,
    nextDayBookingEnd: 10.00,
    somethingElseEnabled: false,
    onlineRatingEnabled: true,
    testimonialCheckboxEnabled: true,
    mandatoryCheckboxIndicatorsEnabled: true,
    GATrackingID: 'UA-128468582-9',
    bookingWindows: [
        { start: '7:30am', end: '8:30am', outOfHours: true },
        { start: '8:30am', end: '10:30am', outOfHours: false },
        { start: '10:30am', end: '12:30pm', outOfHours: false },
        { start: '12:30pm', end: '2:30pm', outOfHours: false },
        { start: '2:30pm', end: '4:30pm', outOfHours: false },
        { start: '5:00pm', end: '6:30pm', outOfHours: true },
    ],
    firebase: {
        apiKey: 'AIzaSyB35WHm4TobaC1uNNYukE6s5HevfHdZ-zU',
        authDomain: 'aahm---book-a-job-development.firebaseapp.com',
        projectId: 'aahm---book-a-job-development',
        storageBucket: 'aanz-dev.appspot.com',
    },
    capability: {
        hasMemberShip: true,
        memberShipConfig: {
            discount: 0.1,
            question: "Are you an AA Member, an AA Insurance Policy holder, or an AA Home Response subscriber?",
            questionType: 9, description: "",
            membershipName: "AA Member Number/AA Insurance Policy Number/AA Home Response or Response Plus Subscriber Number<br>Please do not use space or dash",
            answer: false, memberNumber: ""
        }
    },
    defaultBlackoutDays: 2,
    webserviceURL: "https://clientapi.easylink.experieco.com/",
    localURL: "https://aahm---book-a-job-development.firebaseapp.com/",
    stripeAPIKey: "",
    enableDevTools: true,
    enableMockData: true,
    enableDebugLogging: true,
    logLevel: 'debug',
};
